/** How many recent tools to show under a pending tool-group that isn't fully expanded. */
export const TOOL_GROUP_PEEK_COUNT = 3;

export type ToolGroupBodyMode = 'collapsed' | 'peek' | 'full';

/**
 * Resolve tool-group body presentation.
 * - pending + no override → peek (last N tools)
 * - done + no override → collapsed (header only)
 * - override true → full list
 * - override false → peek while pending, collapsed when done
 */
export function resolveToolGroupBodyMode(
  pending: boolean,
  fullyExpandedOverride: boolean | undefined,
): ToolGroupBodyMode {
  if (fullyExpandedOverride === true) return 'full';
  return pending ? 'peek' : 'collapsed';
}

export function isToolGroupBodyOpen(mode: ToolGroupBodyMode): boolean {
  return mode !== 'collapsed';
}

export function isToolGroupFullyExpanded(mode: ToolGroupBodyMode): boolean {
  return mode === 'full';
}

export function toolGroupVisibleTools<T>(tools: T[], mode: ToolGroupBodyMode): T[] {
  if (mode === 'collapsed') return [];
  if (mode === 'full') return tools;
  return tools.slice(-TOOL_GROUP_PEEK_COUNT);
}
